import Axios from 'axios';
import { apiUrl } from '../config';

const axiosHeaders = {};
const adminAuthToken = localStorage.getItem('admin-auth-token');
const memberAuthToken = localStorage.getItem('member-auth-token');
const sessionToken = localStorage.getItem('session-token');
if (adminAuthToken) {
  axiosHeaders['Admin-Auth-Token'] = adminAuthToken;
}
if (memberAuthToken) {
  axiosHeaders['Member-Auth-Token'] = memberAuthToken;
}
if (sessionToken) {
  axiosHeaders['Authorization'] = `Bearer ${sessionToken}`;
}

const axios = Axios.create({
  baseURL: apiUrl,
  responseType: 'json',
  responseEncoding: 'utf8',
  headers: axiosHeaders,
});

axios.interceptors.request.use((config) => {
  const headers = config.headers || {};
  const common = headers.common || {};
  const adminToken = localStorage.getItem('admin-auth-token');
  const memberToken = localStorage.getItem('member-auth-token');
  const bearer = localStorage.getItem('session-token');

  if (adminToken) {
    headers['Admin-Auth-Token'] = adminToken;
    common['Admin-Auth-Token'] = adminToken;
  }
  if (memberToken) {
    headers['Member-Auth-Token'] = memberToken;
    common['Member-Auth-Token'] = memberToken;
  }
  if (bearer) {
    headers.Authorization = `Bearer ${bearer}`;
    common.Authorization = `Bearer ${bearer}`;
  }

  headers.common = common;
  config.headers = headers;
  return config;
});

axios.interceptors.response.use((response) => {
  const sessionToken = response.headers['session-token'];
  if (sessionToken) {
    localStorage.setItem('session-token', sessionToken);
    axios.defaults.headers.common['Authorization'] = `Bearer ${sessionToken}`;
  }

  return response;
});

export default axios;
